"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "nextI18NextMiddleware", {
  enumerable: true,
  get: function get() {
    return _nextI18nextMiddleware["default"];
  }
});

var _nextI18nextMiddleware = _interopRequireDefault(require("./next-i18next-middleware"));